module.exports = __webpack_public_path__ + "static/ForestScene-6b718b5e94aa20db1947a74222cf3dce.png";